import actionType from "../actionTypes";

const reducerName = actionType.reduxUpdateLearningPlansState;
const base = "/api/learning/accountability";

export default {
  getSettings: (componentRequest) => (dispatch) => {
    global.api.requestAPI({
      axiosParams: { method: "get", url: `${base}/settings` },
      actionType: "learning_accountability_settings_get",
      reducerName,
      dispatch,
      componentRequest,
    });
  },
  saveSettings: (componentRequest) => (dispatch) => {
    global.api.requestAPI({
      axiosParams: { method: "put", url: `${base}/settings` },
      actionType: "learning_accountability_settings_save",
      reducerName,
      dispatch,
      componentRequest,
    });
  },
  // userId is path-only — passport scopes bearer tokens by query.userId, so
  // sending the player's id as ?userId= makes the coach token look invalid.
  historyForPlayer: (componentRequest) => (dispatch) => {
    const { userId, ...params } = componentRequest.params || {};
    global.api.requestAPI({
      axiosParams: {
        method: "get",
        url: `${base}/history/user/${encodeURIComponent(userId)}`,
      },
      actionType: "learning_accountability_history_for_player",
      reducerName,
      dispatch,
      componentRequest: { ...componentRequest, params },
    });
  },
};
